import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import Image from "../../components/Image";
// hooks
import useResponsive from '../../hooks/useResponsive';
import useLocalStorage from '../../hooks/useLocalStorage';


export default function SalaryDialog({ isOpen, close }) {
  const smUp = useResponsive('up', 'sm');
  const [dnd, setDnd] = useLocalStorage('dioCrewEasySalaryDialog', true);

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="xs">
      <DialogTitle variant="h5" sx={{ px: { xs: 3, sm: 4 }, pb: { xs: 3, sm: 4 } }}>
        🎉 인건비 제안이 쉬워졌어요!
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 3, sm: 4 } }}>
        <Image
          sx={{ mb: { xs: 3, sm: 4} }}
          visibleByDefault
          disabledEffect
          src={
            smUp
            ? "https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/salarychart.png"
            : "https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/salarychart-xs.png"
          }
          alt="salarychart"
        />

        <Typography variant="subtitle2" gutterBottom color={(theme) => theme.palette.grey[700]}>
          어떻게 쉬워졌나요?
        </Typography>
        <Typography variant="body2" paragraph color={(theme) => theme.palette.grey[700]}>
          금액을 제안할 때 전체적인 시세 구간 중 내가 속하는 구간을 알 수 있습니다. 이를 통해 쉽게 금액을 작성할 수 있어요.
        </Typography>

        <Button
          sx={{ ml: -1, justifyContent: 'start', color: 'text.secondary' }}
          endIcon={<Iconify icon="ic:chevron-right" />}
          size="medium"
          onClick={() => {window.open('https://dio.oopy.io/faq-price')}}
        >
          자세히 보기
        </Button>

      </DialogContent>
      <DialogActions sx={{ mx: 1, display: smUp ? 'flex': 'block', justifyContent: smUp? 'space-between' : 'inherit' }}>
        <FormGroup sx={{ mb: 1 }}>
          <FormControlLabel
            control={<Checkbox checked={dnd} onClick={() => setDnd(!dnd)} />}
            label="다시 보지 않기"
          />
        </FormGroup>
        <Button variant="contained" fullWidth={!smUp} size="large" sx={{ px: 4 }} onClick={close} >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}